import PlanList from './PlanList';
import PlanShow from './PlanShow';
import UserIcon from '@material-ui/icons/Group';

export default {
  show: PlanShow,
};
